var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-setting"},[_c('blog-type-input',{attrs:{"id":_vm.id,"label":_vm.label,"type":_vm.type,"listSource":_vm.listSource,"initialValue":_vm.value},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }